export const BlockAccRedBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="69"
    fill="none"
    viewBox="0 0 69 69"
    {...props}>
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.426"
      fill="#FEE4E2"
      rx="28"></rect>
    <rect
      width="60"
      height="60"
      x="4.5"
      y="4.426"
      stroke="#FEF3F2"
      strokeWidth="8"
      rx="28"></rect>
    <path
      stroke="#D32F2F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M34.5 46.926c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5-12.5 5.6-12.5 12.5 5.6 12.5 12.5 12.5zM43.125 25.676l-17.5 17.5"></path>
  </svg>
);
